import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Box } from '@mui/material';
import FinmapleComparator from '../components/Comparator/FinmapleComparator';
import NewsletterSection from '../components/Layout/NewsletterSection';
import SEOHead from '../components/SEO/SEOHead';
import PageHeader from '../components/Layout/PageHeader';
import AtomicAnswer from '../components/SEO/AtomicAnswer';
import FAQSection from '../components/SEO/FAQSection';
import CrossLinks from '../components/Layout/CrossLinks';
import {
  GIC_SEO,
  GIC_PAGE_HEADER,
  GIC_ATOMIC_ANSWER,
  GIC_CROSS_LINKS,
  GIC_FAQS,
} from '../data/gicRates';

const GICRatesPage = () => {
  const { i18n } = useTranslation();
  return (
  <Box sx={{ bgcolor: 'neutral.50' }}>
    <SEOHead
      seoKey="gicRates"
      title={GIC_SEO.title}
      description={GIC_SEO.description}
      canonical={GIC_SEO.canonical}
      routeKey="gicRates"
      schema={GIC_SEO.schema}
      noIndex={i18n.language !== 'es'}
    />
    <PageHeader
      variant="minimal"
      title={GIC_PAGE_HEADER.title}
      subtitle={GIC_PAGE_HEADER.subtitle}
      breadcrumbs={GIC_PAGE_HEADER.breadcrumbs}
      maxWidth="lg"
    />
    <Container maxWidth="lg" sx={{ mb: 2 }}>
      <AtomicAnswer text={GIC_ATOMIC_ANSWER} />
    </Container>
    <Container maxWidth="lg">
      <FinmapleComparator category="gics" />
      <CrossLinks links={GIC_CROSS_LINKS} />
      <FAQSection faqs={GIC_FAQS} />
    </Container>
    <NewsletterSection />
  </Box>
  );
};

export default GICRatesPage;
